import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { vatRate: Number }
  static targets = ["salesPrice", "priceWithVat", "quantity", "totalPrice", "taskTotal"]

  connect() {
    this.#syncFromSalesPrice()
    this.updateTaskTotal()
  }

  taskTypeSelected(event) {
    const price = event.detail.meta?.price
    if (!price || parseFloat(price) <= 0) return
    this.salesPriceTarget.value = parseFloat(price).toFixed(2)
    this.#syncFromSalesPrice()
    this.updateTaskTotal()
  }

  updateFromPriceWithVat() {
    const withVat = parseFloat(this.priceWithVatTarget.value)
    if (isNaN(withVat) || withVat < 0) return
    const multiplier = 1 + this.vatRateValue / 100
    this.salesPriceTarget.value = (withVat / multiplier).toFixed(2)
    if(this.hasQuantityTarget && this.hasTotalPriceTarget) {
      const quantity = parseFloat(this.quantityTarget.value)
      this.totalPriceTarget.value = ((withVat / multiplier) * quantity).toFixed(2)
    }
    this.updateTaskTotal()
  }

  updateFromSalesPrice() {
    this.#syncFromSalesPrice()
    this.updateTaskTotal()
  }

  updateTaskTotal() {
    if ((!this.hasTaskTotalTarget && !this.hasTotalPriceTarget) || !this.hasQuantityTarget || !this.hasSalesPriceTarget) return

    let total = this.#number(this.quantityTarget.value) * this.#number(this.salesPriceTarget.value)
    this.element.querySelectorAll("[data-task-part-row]").forEach((row) => {
      const destroyField = row.querySelector("input[name$='[_destroy]']")
      if (destroyField?.value === "1") return

      const quantity = row.querySelector("input[name$='[quantity]']")
      const unitPrice = row.querySelector("input[name$='[unit_price]']")
      total += this.#number(quantity?.value) * this.#number(unitPrice?.value)
    })

    const locale = document.documentElement.lang || "en"
    if (this.hasTaskTotalTarget) {
      this.taskTotalTarget.textContent = new Intl.NumberFormat(locale, {
        style: "currency",
        currency: "EUR"
      }).format(total)
    }
    if (this.hasTotalPriceTarget) {
      this.totalPriceTarget.value = (total * (1 + this.vatRateValue / 100)).toFixed(2)
    }
  }

  scheduleTaskTotal() {
    requestAnimationFrame(() => this.updateTaskTotal())
  }

  #syncFromSalesPrice() {
    const withoutVat = parseFloat(this.salesPriceTarget.value)
    if (isNaN(withoutVat) || withoutVat <= 0) return
    const multiplier = 1 + this.vatRateValue / 100
    this.priceWithVatTarget.value = (withoutVat * multiplier).toFixed(2)
    if(this.hasQuantityTarget && this.hasTotalPriceTarget) {
      const quantity = parseFloat(this.quantityTarget.value)
      this.totalPriceTarget.value = (withoutVat * multiplier * quantity).toFixed(2)
    }
  }

  #number(value) {
    const number = parseFloat(value)
    return Number.isFinite(number) ? number : 0
  }
}
